import { z } from "zod";

export const FeedbackTypeSchema = z.enum([
  "bug",
  "feature_request",
  "improvement",
  "other",
]);
export type FeedbackType = z.infer<typeof FeedbackTypeSchema>;

export const FeedbackStatusSchema = z.enum([
  "pending",
  "in_progress",
  "resolved",
  "dismissed",
]);
export type FeedbackStatus = z.infer<typeof FeedbackStatusSchema>;

export const FeedbackSchema = z.object({
  id: z.uuid(),
  user_id: z.string().nullable(), // Firebase UID, not UUID format
  feedback_type: FeedbackTypeSchema,
  title: z.string(),
  description: z.string(),
  status: FeedbackStatusSchema,
  metadata: z.record(z.string(), z.unknown()).nullable(),
  version: z.string().nullable(), // Application version
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
});
export type Feedback = z.infer<typeof FeedbackSchema>;

export const CreateFeedbackSchema = z.object({
  feedback_type: FeedbackTypeSchema,
  title: z.string().min(3, "Title must be at least 3 characters long"),
  description: z
    .string()
    .min(5, "Description must be at least 5 characters long"),
  metadata: z.record(z.string(), z.unknown()).optional(),
  version: z.string().optional(), // Application version
});
export type CreateFeedbackInput = z.infer<typeof CreateFeedbackSchema>;
